import React from 'react';
import { Input, Button } from 'antd';
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { compose } from 'redux';
import { translate } from 'react-i18next';
class TeacherProfile extends React.Component {

  state = {
    pass0: "",
    pass2: "",
    error: ""
  }

  changePass = () => {
    const { t } = this.props
    let _this = this
    if (this.state.pass1 != this.state.pass2) {
      this.setState({error: t("Passwords do not match.")})
    } else {
        let email = this.props.firebase.auth().currentUser.email
        let password = this.state.pass0
        let credential = this.props.firebase.auth.EmailAuthProvider.credential(
            email,
            password
        );
      let user = this.props.firebase.auth().currentUser;
      user.reauthenticateAndRetrieveDataWithCredential(credential).then(function() {
        user.updatePassword(_this.state.pass1).then(function() {
          _this.props.firebase.logout()
          }).catch(function(error) {
            _this.setState({error: error.message})
          });
      }).catch(function(error) {
        _this.setState({error: error.message})
      });
    }
  }

  render() {
    const { t } = this.props
    return (
      <div style={styles.container}>
        <h1 style={{fontWight: 'bold'}}>{t('Teacher Profile Settings')}</h1>
        <h2>{t('Change Password')}</h2>
        <Input
          type="password"
          placeholder={t("Current password")}
          value={this.state.pass0}
          onChange={(e) => this.setState({pass0: e.target.value})}
          style={styles.input}
        />
        <br />
        <Input
          type="password"
          placeholder={t("New password")}
          value={this.state.pass1}
          onChange={(e) => this.setState({pass1: e.target.value})}
          style={styles.input}
        />
        <br />
        <Input
          disabled={this.state.pass1 == ""}
          type="password"
          placeholder={t("Confirm new password")}
          value={this.state.pass2}
          onChange={(e) => this.setState({pass2: e.target.value})}
          style={styles.input}
        />
        <br />
        <Button disabled={this.state.pass2 == ""} onClick={() => this.changePass()} type="primary">{t('Change Password')}</Button>
        <p style={styles.error}>{this.state.error}</p>
      </div>
    )
  }
}

const enhancer = compose(
  translate('lang'),
  firebaseConnect((props) => {})
)
export default enhancer(TeacherProfile);

const styles = {
  error: {
    fontSize: '14px',
    color: 'red'
  },
  container: {
    margin: 20,
    padding: 40,
    backgroundColor: 'white'
  },
  input: {
    width: 300,
    marginBottom: 20
  }
}



// WEBPACK FOOTER //
// ./src/containers/TeacherProfile/index.jsx